import ChallengeItemTable from './ChallengeItemTable';

export default ChallengeItemTable;
